
export default {
    name: 'LeeNotificationItem',
    data() {
        return {

        }
    },
    mounted() {

    },
    computed: {

    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        }
    }
};
